<template>
  <div class="eat-map">
    <div class="map-wrapper">
      <div :id="uniqueMapID" class="map">
        <div class="leaflet-top leaflet-right">
          <div class="center-btn button is-white is-rounded" @click="recenter">
            <i class="fa fa-crosshairs" :class="{ 'fa-spin': spin }" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from "../eventBus";
import L from "leaflet";
// import "leaflet-edgebuffer";
import "leaflet.awesome-markers";

export default {
  name: "EatMap",
  data() {
    return {
      uniqueMapID: "eat-map-map",
      map: undefined,
      spin: false,
      userMarker: null,
      stateLayer: undefined,
      //   filters: null, // will be set to an object if filters used
      filters: {
        cuisineOptions: [],
        promoOptions: [],
        fulfilmentOptions: [],
        openNowToggle: true,
        distance: 12,
      },
      search: null,
      forceRegion: false,
    };

    // cuisines = this.filters.cuisineOptions
    // promos = this.filters.promoOptions
    // fulfilment = this.filters.fulfilmentOptions
    // openNowToggle = this.filters.openNowToggle
    // distance = this.filters.distance
  },
  computed: {
    cuisines() {
      return this.filters.cuisineOptions;
    },
    promos() {
      return this.filters.promoOptions;
    },
    fulfilment() {
      return this.filters.fulfilmentOptions;
    },
    openNowToggle() {
      return this.filters.openNowToggle;
    },
    distance() {
      return this.filters.distance;
    },
    businesses() {
      //   return this.$store.state.eateries; // this.$store.getters.getShops;

      var shops = this.$store.state.eateries; //this.$store.getters.getShops;
      shops = shops.filter((b) => !b.data.hidden); // hide hidden shops from list

      if (this.search) {
        shops = shops.filter((b) => {
          if (b.name.toLowerCase().includes(this.search)) return true;
          if (
            b.data.categories &&
            b.data.categories.toLowerCase().includes(this.search)
          )
            return true;
          return false;
        });
      }

      shops = shops.filter((b) => {
        if (this.fulfilment.length == 0) return true; // all okay if none specified
        if (this.fulfilment.includes("delivery")) {
          if (this.isAnyDelivery(b)) return true;
        }
        if (this.fulfilment.includes("take-away")) {
          if (this.isTakeAway(b)) return true;
        }
        if (this.fulfilment.includes("dine-in")) {
          return true;
        }
      });

      shops = shops.filter((b) => {
        if (!b.distance || this.forceRegion) return true;
        return b.distance < this.distance * 1000; // meters
      });

      if (this.cuisines.length > 0) {
        shops = shops.filter((b) => {
          if (!b.data.categories) return false;
          var categories = b.data.categories;
          for (var i = 0; i < this.cuisines.length; i++) {
            if (categories.includes(this.cuisines[i])) return true;
          }
          return false;
        });
      }

      if (this.openNowToggle) {
        shops = shops.filter((b) => {
          return this.businessIsOpenNow(b);
        });
      }

      if (this.promos.length > 0) {
        shops = shops.filter((b) => {
          if (this.promos.includes("free-delivery")) {
            if (this.isFreeDelivery(b)) return true;
          }
        });
      }

      return shops;
    },
  },
  created() {
    L.AwesomeMarkers.Icon.prototype.options.prefix = "fa";
  },
  activated() {
    // this.$nextTick(() => this.map.invalidateSize());
    var coords = this.$store.getters.getUserLatLon;
    this.map.setView(coords, 14);
    console.log("activated ShopMap", coords);
    this.redraw();
  },
  mounted() {
    this.initMap();
    EventBus.$on("UPDATE_IOS_LOCATION", (location) => {
      this.map.fire("locationfound", { latlng: location });
    });
    EventBus.$on("UPDATE_SHOP_MAP", () => this.drawMarkers());
    EventBus.$on("TOGGLE_SHOP_MAP", () => this.drawMarkers());
    EventBus.$on("APPLY_EAT_FILTERS", (filters) => {
      this.filters = filters;
      // should remove existing shops and redraw new shops...
    });
  },
  methods: {
    redraw() {
      setTimeout(() => this.map.invalidateSize(), 50);
    },
    businessIsOpenNow(b) {
      var today = this.$date.getShortDay(); //new Date().toLocaleString("en-US", { weekday: "short" });
      if (this.onHoliday(b)) return false;
      if (b.data.hours_type === "always-open") return true;
      if (!b.data.hours) return true; // unknown hours, say open
      var hours = b.data.hours[today.toLowerCase()];
      if (hours && this.openNow(hours)) return true;
      return false;
    },
    onHoliday(b) {
      var commerce = this.commerceWorkflow(b);
      if (!commerce || !commerce.data.closed_until) return false;
      return this.isFutureTime(commerce.data.closed_until);
    },
    initMap() {
      var tilesURL = this.$t("geo.map-tiles"); // language specific maps

      this.map = L.map(this.uniqueMapID, {
        attributionControl: false,
        doubleClickZoom: true,
      });

      L.tileLayer(tilesURL, {
        // edgeBufferTiles: 1,
        tileSize: 512,
        zoomOffset: -1,
        minZoom: 3,
        maxZoom: 19,
      }).addTo(this.map);
      // this.map.invalidateSize();
      this.stateLayer = L.featureGroup().addTo(this.map);
      var userCoords = this.$store.state.userState;
      this.map.setView(userCoords, 13); // set zoom level 13

      this.drawMarkers();
      this.drawUserMarker();
    },
    drawUserMarker() {
      var coords = this.$store.getters.getUserLatLon;
      var icon = L.divIcon({
        html: `<div class="blue-dot pulse"></div>`,
        popupAnchor: [7, -6],
        className: "none",
      });
      this.userMarker = L.marker(coords, { icon: icon });
      this.userMarker.addTo(this.map);
      var popupOpts = { closeButton: false, autoPan: true };
      this.userMarker.bindPopup(this.$t("ride.your-current-gps"), popupOpts);
    },
    drawMarkers() {
      this.drawBusinessMarkers();
      this.redraw();
      // this.map.flyToBounds(this.stateLayer.getBounds());
    },
    drawBusinessMarkers() {
      this.stateLayer.clearLayers(); // clear first
      var defaultProfilePic = `https://i.ibb.co/DK0f6y3/TUK-Esssentials-profile.png`;
      var defaultBannerPic = `https://www.khaosodenglish.com/wp-content/uploads/2019/02/DSC06061.jpg`;
      // loop through each business and draw it on the map
      this.businesses.forEach((b) => {
        if (!b.profile_pic_url) return;
        var triangleIcon = L.divIcon({
          className: "triangle-div-icon",
          iconAnchor: [10, 16],
        });
        L.marker(b, { icon: triangleIcon }).addTo(this.stateLayer);
        var icon = L.icon({
          iconUrl: b.profile_pic_url || defaultProfilePic, // shadowUrl: "leaf-shadow.png",
          className: "profile-pic-round",
          iconSize: [40, 40], // size of the icon // shadowSize: [50, 64],
          iconAnchor: [20, 50], // point of the icon which will correspond to marker's location // shadowAnchor: [4, 62],
          popupAnchor: [0, -50],
        });
        var marker = L.marker(b, { icon: icon }).addTo(this.stateLayer);
        var opts = { closeButton: false, autoPan: true, maxWidth: "auto" };
        // var txt = `<a href="/shop/${b.id}">${b.name}</a><br>${b.business_type}`;
        var bannerPicURL = b.banner_pic_url || defaultBannerPic;
        var shortName = this.shortenString(b.name, 25);
        var html = `<div style="width:200px" onclick="leafletRouter('/shop/${b.id}')">
        <a style="font-size:1.25em;">${shortName}</a><br>
        <span style="position:absolute; top:30px; left:8px; font-weight:bold; background-color:white; padding:2px; border-radius:4px; opacity:0.8">${b.business_type}</span>
        <img src='${bannerPicURL}' width="200" style="background-color:rgba(255, 217, 0, 0.5); border-radius:4px; max-height:150px; object-fit:cover" /></div>`;
        if (this.businessIsOpenNow(b)) {
          html += `<i style='position:absolute; top:32px; right:10px; width:12px; height:12px; background-color:lightgreen; border-radius:50%; border: 1px solid white; box-shadow:1px 1px 3px black'></i>`;
        } else {
          html += `<i style='position:absolute; top:32px; right:10px; width:12px; height:12px; background-color:#FF3860; border-radius:50%; border: 1px solid white; box-shadow:1px 1px 3px black'></i>`;
        }
        marker.bindPopup(html, opts);
      });
    },
    recenter() {
      var coords = this.$store.getters.getUserLocation;
      this.updateMarkerLocation(coords, true);
      this.spin = true;
      setTimeout(() => (this.spin = false), 600);
    },
    updateMarkerLocation(coords, flyTo) {
      this.userMarker.setLatLng(coords);
      if (flyTo) this.map.flyTo(coords);
      else this.map.setView(coords, 17);
    },

    ////// copied from EatList.vue /////
    commerceWorkflow(b) {
      if (!b.workflows) return false;
      return b.workflows.find((w) => w.workflow_type_name === "Commerce");
    },
    isFreeDelivery(b) {
      var commerce = this.commerceWorkflow(b);
      if (!commerce) return false;
      if (commerce.data.free_delivery) return true;
      return false;
    },
    isDelivery(b) {
      var commerce = this.commerceWorkflow(b);
      if (!commerce) return false;
      if (commerce.data.free_delivery) return false;
      if (commerce.data.delivery) return true;
      return false;
    },
    isAnyDelivery(b) {
      return this.isDelivery(b) || this.isFreeDelivery(b);
    },
    isTakeAway(b) {
      if (!b.workflows) return false;
      return true;
    },
  },
};
</script>

<style scoped>
.map-wrapper {
  height: calc(100vh - 159px);
  width: 100%;
}
.map {
  position: relative;
  height: 100%;
  width: 100vw;
  border-top: 1px solid lightgrey;
  z-index: 1;
}
.center-btn {
  margin: 10px;
  padding: 0 9px;
  pointer-events: auto;
  /* color: rgb(0, 106, 255); */
  color: grey;
  box-shadow: 0 0 3px grey;
}
</style>

<style lang="scss">
#eat-map-map {
  .profile-pic-round {
    /* object-fit: cover; */
    border-radius: 50%;
    border: 1px solid white;
    filter: drop-shadow(1px 1px 2px #555);
  }
  .triangle-div-icon {
    width: 0;
    height: 0;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-top: 16px solid white;
    filter: drop-shadow(1px 1px 2px #555);
  }
  .leaflet-popup-content {
    padding: 5px 5px;
    margin: 1px 0;
    color: rgb(62, 77, 77);
    /* color: #209cee; */
  }
  .leaflet-bar a,
  .leaflet-bar a:hover {
    text-decoration: none !important;
  }
  //   .leaflet-control-zoom a {
  //     border-radius: 50%;
  //   }
  .leaflet-control-locate {
    border-radius: 50%;
  }
  .leaflet-control-locate a {
    border-radius: 50%;
  }
  .blue-dot {
    margin-left: 6px;
    height: 15px;
    width: 15px;
    border-radius: 50%;
    background-color: #2693da;
    opacity: 0.9;
    border: 1px solid #feeaa4b5;
  }
  .pulse {
    animation: pulsate-1 3s ease-out infinite;
  }
  @keyframes pulsate-1 {
    0% {
      box-shadow: 0 0 0 1px cyan;
    }
    50% {
      box-shadow: 0 0 0 6px rgba(255, 217, 0, 0.5);
    }
    100% {
      box-shadow: 0 0 0 1px lightskyblue;
    }
  }
}
</style>